import appStore from 'store'
import api from './api'
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  PAGINATION,
} from './constants'

const store = {
  namespaced: true,
  state: {
    hasPrev: '',
    hasNext: null,
    orderList: [],
    userList: [],
    detailList: [],
    pairList: [],
    totalCount: 0,
    detailTotal: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    queryType: QUERY_TYPE[0].value,
    userinfoDetail: {},
    userinfoDetailDialogVisible: false,
    dialogVisible: false,
    notedetail: {},
    countryCodeList: [],
  },
  getters: {
    userList: (state) =>
      state.userList.map((item) => {
        return {
          ...item,
          __registerFrom: REGISTER_FORM[item.registerFrom],
          __userStatus: USER_STATUS[item.userStatus],
          __bankAuthStatus: BANK_AUTH_STATUS[item.bankAuthStatus],
          __idNoStatus: ID_NO_STATUS[item.idNoStatus || 0],
          __emailSecurityStatus:
            EMAIL_SECURITY_STATUS[item.emailSecurityStatus || 0],
          __phoneSecurityStatus:
            PHONE_SECURITY_STATUS[item.phoneSecurityStatus || 0],
          __googleSecurityStatus:
            GOOGLE_SECURITY_STATUS[item.googleSecurityStatus || 0],
          __userVolunteerStatus:
            USER_VALUNTEER_STATUS[item.userVolunteerStatus || 0],
          __userBlockingStatus: USER_BLOCKING_STATUS[item.userStatus || 0],
        }
      }),
  },
  mutations: {
    setOrderList(state, payload) {
      state.orderList = payload ? payload.items.slice() : []
      // state.totalCount=payload.data.items.length
    },
    setDetailList(state, payload) {
      state.detailList = payload.data.items
      state.detailTotal = payload.data.total
    },
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.detailTotalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload
    },
    setdialogVisible(state, payload) {
      state.dialogVisible = payload
    },
    setnodedetail(state, payload) {
      state.notedetail = payload
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload
    },
    setPairList(state, payload) {
      state.pairList = payload
    },
    setPrev(state, payload) {
      state.hasPrev = payload
    },
    setNext(state, payload) {
      state.hasNext = payload
    },
  },
  actions: {
    //获取pairList
    getPairList({ commit }) {
      api.getPairList().then((res) => {
        commit('setPairList', res.data)
      })
    },

    //动态条件查询
    getOrderList({ commit }, data) {
      api.getOrderList(data).then((res) => {
        commit('setOrderList', res.data)
        commit('setPrev', res.data.hasPrev)
        commit('setNext', res.data.hasNext)
      })
    },
    //撤销订单
    cancleOrder({ commit }, orderId) {
      return api.cancleOrder(orderId).then((res) => {
        return res
      })
    },
    //查询成交列表明细
    getOrderDetails({ commit }, data) {
      const { page, size } = data;
      commit('setPagination', { page, size })
      return api.getOrderDetails(data).then((res) => {
        commit('setDetailList', res)
        return res
      })
    },
    //一键撤销
    cancelAll({ commit }, data) {
      return api.cancelAll(data).then((res) => {
        return res
      })
    },
  },
}

appStore.registerModule('active', store)
